/**
 * Generated by `pnpm generate:sdk-types` — DO NOT EDIT BY HAND.
 *
 * `PluginPermission` union + `VALID_PLUGIN_PERMISSIONS` const,
 * sourced from `@fias/db-types`. Generated (not re-exported) so the
 * SDK has no runtime dependency on db-types — the SDK ships in
 * plugin iframes and must stay bundle-clean.
 *
 * `tests/architecture/sdk-permissions-match-db-types.test.ts` ensures
 * this file stays in lockstep with the canonical source.
 */

export type PluginPermission =
  | 'assets:read'
  | 'data:search'
  | 'data:store'
  | 'data:workspace'
  | 'entities:audio_generate'
  | 'entities:client_invoke'
  | 'entities:image_edit'
  | 'entities:image_generate'
  | 'entities:image_remove_background'
  | 'entities:invoke'
  | 'navigation:open_arche'
  | 'sandbox:vendored-libraries'
  | 'storage:sandbox'
  | 'store:purchase'
  | 'theme:read'
  | 'user:profile:read'
  | 'vault:documents:read'
  | 'vault:documents:write';

export const VALID_PLUGIN_PERMISSIONS: readonly PluginPermission[] = [
  'assets:read',
  'data:search',
  'data:store',
  'data:workspace',
  'entities:audio_generate',
  'entities:client_invoke',
  'entities:image_edit',
  'entities:image_generate',
  'entities:image_remove_background',
  'entities:invoke',
  'navigation:open_arche',
  'sandbox:vendored-libraries',
  'storage:sandbox',
  'store:purchase',
  'theme:read',
  'user:profile:read',
  'vault:documents:read',
  'vault:documents:write',
] as const;

export function isValidPluginPermission(perm: string): perm is PluginPermission {
  return (VALID_PLUGIN_PERMISSIONS as readonly string[]).includes(perm);
}
